import React, { useState } from 'react'

import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useBoolean } from '@fluentui/react-hooks';

import { Card, Row, Col } from "react-bootstrap"
import { Toggle } from '@fluentui/react/lib/Toggle';

import ToolBar from '../../../../components/Common/Toolbar';
import CTextBox from '../../../../components/Common/CTextBox';
import CLabel from '../../../../components/Common/CLabel';
import StatusHeaderItem from '../StatusHeaderItem';
import Message from '../../../Common/Message';
import {createBook, saveBook} from "../../../../services/sBook/book.service";
import { useGetBookById } from '../../../../hooks/services/sBook/useOfBook';

import '../../../../styles/scss/ProgressBar.scss';
import ToolBarDownFall from '../ToolbarDownFall';
import SidePanelSections from './SidePanelSections';
import SidePanelPartys from './SidePanelPartys';
import SidePanelViewUsers from '../SidePanelViewUsers';
import DocumentLinkModal from '../MessageTree/DocumentLinkModal';
import { ActionButton, Icon, mergeStyleSets, css, TooltipHost, TooltipOverflowMode } from '@fluentui/react';
import SidePanelImpersonate from './SidePanelImpersonate';
import { useGetDocumentListByBook } from '../../../../hooks/services/sBook/useOfDocument';
import { getGlobalMessageLayout, isNullUndefinedOrEmpty, isNullUndefinedOrEmptyOrZero, setGlobalMessageLayout } from '../../../../common/Helpers';
import { __enum_SystemPages, __SystemPagesPaths } from '../../../../common/Dictionaries';
import { TeachBubble } from '../../../Templates/TeachBubble';
import { useSelector } from 'react-redux';

function BookBox(props) {
    const { t } = useTranslation();
    const history = useHistory();

    const { _fireSetBook: fireSetBook } = useSelector((state) => state.bookState);

    //Parametros de entrada.
    const inputParam_QueryStringBookId = props.queryStringBookId;
    const inputParam_SetterBookObject = props.setterBookObject;
    const inputParam_EditMode = props.editMode !== null && props.editMode !== undefined ? props.editMode : true;
    const inputParam_ShowImpersonation = props.showImpersonation !== null && props.showImpersonation !== undefined ? props.showImpersonation : false;
    const inputParam_ShowNumber = props.showNumber !== null && props.showNumber !== undefined ? props.showNumber : true;
    const inputParam_ShowSwitchLayout = props.showSwitchLayout !== null && props.showSwitchLayout !== undefined ? props.showSwitchLayout : true;
    const inputParam_SetterUserPropsObject = props.setterUserPropsObject !== null && props.setterUserPropsObject !== undefined ? props.setterUserPropsObject : null;
    const inputParam_SetterObjMessageList = props.setterObjMessageList !== null && props.setterObjMessageList !== undefined ? props.setterObjMessageList : null;
    const inputParam_SetterUserName = props.setterUserName !== null && props.setterUserName !== undefined ? props.setterUserName : null;
    const inputParam_SetterQueryStringBookId = props.setterQueryStringBookId !== null && props.setterQueryStringBookId !== undefined ? props.setterQueryStringBookId : null;
    const inputParam_RelatedConceptItem = props.relatedConceptItem !== null && props.relatedConceptItem !== undefined ? props.relatedConceptItem : null;
    
    const inputParam_UserProps = props.userProps !== null && props.userProps !== undefined ? props.userProps : null;
    const inputParam_UserHasConfigRoleAction = props.userHasConfigRoleAction !== null && props.userHasConfigRoleAction !== undefined ? props.userHasConfigRoleAction : false;
    const inputParam_IsCreatrionMode = props.isCreatrionMode !== null && props.isCreatrionMode !== undefined ? props.isCreatrionMode : false;
    const inputParam_StatusFly = props.statusFly !== null && props.statusFly !== undefined ? props.statusFly : null;
    
    const classNames = mergeStyleSets({
        overflow: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    });

    //Parametros de componente.
    const [isPanelViewPartysOpen, setIsPanelViewPartysOpen] = useState(false);
    const [isPanelViewSectionsOpen, setIsPanelViewSectionsOpen] = useState(false);
    const [isPanelImpersonateOpen, setIsPanelImpersonateOpen] = useState(false);
    const [isPanelViewUsersOpen, setIsPanelViewUsersOpen] = useState(false);
    const [isModalDocumentOpen, setIsModalDocumentOpen] = useState(false);
    
    
    const [successful, setSuccessful] = useState(null);
    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState(null);
    const [showMessage, setShowMessage] = useState(false);

    const [objBook, setObjBook] = useState({
        bookCode: " ",
        bookNemo: null,
        id: null,
        name: "",
        requiresApproval: false,
        autoSignature: false,
        hasMilestone: false,
        mainBook: false,
        statusId: 1
    });
    useGetBookById(inputParam_QueryStringBookId, objBook.id, setSuccessful, setMessage, setObjBook, inputParam_SetterBookObject, fireSetBook, inputParam_UserProps)

    const [txtNameIsInValid, setTxtNameIsInValid] = useState(false);
    const [txtCodeIsInValid, setTxtCodeIsInValid] = useState(false);

    //const [documentLinkList, setDocumentLinkList] = useState(null);
    //const [documentGetFired, setDocumentGetFired] = useState(null);
    //useGetDocumentListByBook(objBook !== null ? objBook.id : 0, documentLinkList, setDocumentLinkList, documentGetFired, setDocumentGetFired, inputParam_UserProps.partyMemberId);
    
    const [selectedImpersonateUser, setSelectedImpersonateUser] = useState(null);
  


    //Funciones de componente.
    const setNameValue = (value) => {
        setTxtNameIsInValid(value==="");
        setObjBook(prevState => ({ ...prevState, name: value }));
    };
    const setCodeValue = (value) => {
        setTxtCodeIsInValid(value==="");
        setObjBook(prevState => ({ ...prevState, bookCode: value }));
    };
    const validateForm = (obj) => {
        const validName = obj.name !== "";
        const validCode = obj.bookCode !== "";

        //Toggle de "Requiere aprobacion" no se valida ya que por defecto siempre posee un valor.
        //validRequiresApproval = tglRequiersApprovalValue !== null;

        return validName && validCode;
    };



    //Eventos de componente.
    const onCreateBook = (e) => {
        let formIsValid = validateForm(objBook);

        if (formIsValid === true) {
            
            //Crear elemento libro.
            createBook(objBook).then((response) => {
                setSuccessful(true);

                setShowMessage(true)
                setSuccessful(true);
                setMessageType("success");
                setMessage(t('data-lang-msg-operationperformed'))

                inputParam_SetterQueryStringBookId && inputParam_SetterQueryStringBookId(response.data.data);

                setObjBook({
                    bookCode: " ",
                    bookNemo: null,
                    id: null,
                    name: "",
                    requiresApproval: false,
                    autoSignature: false,
                    hasMilestone: false,
                    mainBook: false,
                    statusId: 1
                })

                history.push({
                    pathname: `${__SystemPagesPaths[__enum_SystemPages.BookCreation].text}/${ response.data.data }`
                })


            }).catch(() => {
                setShowMessage(true)
                setSuccessful(false);
                setMessageType("error");
                setMessage(t('data-lang-msg-operationerror'))
            });
        } else {
            //Alertar que algo interrumpe la creacion del libro.
            setNameValue(objBook.name);
            setCodeValue(objBook.bookCode);

            setShowMessage(true)
            setSuccessful(false);
            setMessageType("warning");
            setMessage(t('data-lang-msg-requireddatanotset'))
        }
    };
    const onSaveBook = (e) => {
        let formIsValid = validateForm(objBook);

        if (formIsValid === true) {
            //Guardar elemento libro.
            saveBook(objBook).then(() => {
                inputParam_SetterBookObject && inputParam_SetterBookObject(objBook)
                setShowMessage(true)
                setSuccessful(true);
                setMessageType("success");
                setMessage(t('data-lang-msg-operationperformed'))
            }).catch(() => {
                setShowMessage(true)
                setSuccessful(false);
                setMessageType("error");
                setMessage(t('data-lang-msg-operationerror'))
            });
        } else {
            //Alertar que algo interrumpe la creacion del libro.
            setNameValue(objBook.name);
            setCodeValue(objBook.bookCode);

            setShowMessage(true)
            setSuccessful(false);
            setMessageType("warning");
            setMessage(t('data-lang-msg-requireddatanotset'))
        }
    };
    const onCancel = (e) => {
        //Redireccionar a alguna pagina.
        alert("onCancel.");
    };
    const onViewPartys = (e) => {
        setIsPanelViewPartysOpen(true);
    };
    const onViewSections = (e) => {
        setIsPanelViewSectionsOpen(true);
    };
    const onViewUsers = (e) => {
        setIsPanelViewUsersOpen(true);
    };
    const onViewDocuments = () => {
        //setDocumentLinkList(null);
        //setDocumentGetFired(true);
        setIsModalDocumentOpen(true)
    }
    const onShowImpersonation = (e) => {
        setIsPanelImpersonateOpen(true);
    };
    const onRequiresApprovalChange = (e, checked) => {
        setObjBook(prevState => ({
            ...prevState,
            requiresApproval: checked
        }));
    };

    const onAutoSignatureChange = (e, checked) => {
        setObjBook(prevState => ({
            ...prevState,
            autoSignature: checked
        }));
    };

    const onHasLapsChange = (e, checked) => {
        setObjBook(prevState => ({
            ...prevState,
            hasMilestone: checked
        }));

        inputParam_SetterBookObject && inputParam_SetterBookObject(prevState => ({
            ...prevState,
            hasMilestone: checked
        }));
    };

    const onViewBookMessages = (e) => {

        if (window.location.pathname.toString().toLowerCase().startsWith(__SystemPagesPaths[__enum_SystemPages.BookCreation].text.toLocaleLowerCase())) {
            //[#NEW31082026#]SE COMENTA POR QUE LAS OTRAS VERSIONES TIENEN PROBLEMAS.
            const userLayoutVersion = "V3"//getGlobalMessageLayout()
            if (userLayoutVersion === "V1") {
                history.push({
                    pathname: `${__SystemPagesPaths[__enum_SystemPages.Book].text}/${ objBook.id }`,
                })  
            }
            else if (userLayoutVersion === "V2") {
                history.push({
                    pathname: `${__SystemPagesPaths[__enum_SystemPages.BookV2].text}/${ objBook.id }`,
                })
            }
            else if (userLayoutVersion === "V3") {
                history.push({
                    pathname: `${__SystemPagesPaths[__enum_SystemPages.BookV3].text}/${ objBook.id }`,
                })
            }
            else {
                history.push({
                    pathname: `${__SystemPagesPaths[__enum_SystemPages.BookV3].text}/${ objBook.id }`,
                })
            }
        }
        else {
            history.push({
                pathname: `${__SystemPagesPaths[__enum_SystemPages.BookCreation].text}/${ objBook.id }`
            })
        }
    };
    const onSwitchLayout = (version) => {
        switch (version) {
            case "V1":
                setGlobalMessageLayout("V1")
                history.push({
                    pathname: `${__SystemPagesPaths[__enum_SystemPages.Book].text}/${ objBook.id }`,
                })  
                break;
            case "V2":
                setGlobalMessageLayout("V2")
                history.push({
                    pathname: `${__SystemPagesPaths[__enum_SystemPages.BookV2].text}/${ objBook.id }`,
                })
                break;
            case "V3":
                setGlobalMessageLayout("V3")
                history.push({
                    pathname: `${__SystemPagesPaths[__enum_SystemPages.BookV3].text}/${ objBook.id }`,
                })
                break;
            default:
                break;
        }
    };
    
    //Constante resagada, esto dado que deben existir los eventos del comonente para poder ser invocados en array de toolbar.
    const toolBarItems_BookInfo_Edit  = [
        {
            key: 'cancel',
            text: t('data-lang-btn-cancel'),
            iconProps: { iconName: 'NavigateBack' },
            onClick: onCancel,
        },
    ];

    const toolBarItems_BookInfo_SwitchLayout = {
        items: [
            {
                key: 'V1',
                text: t('data-lang-btn-view-v1'),
                //iconProps: { iconName: 'View' },
                onClick:  () => onSwitchLayout("V1"),
            },
            {
                key: 'V2',
                text: t('data-lang-btn-view-v2'),
                //iconProps: { iconName: 'AssessmentGroupTemplate' },
                onClick:  () => onSwitchLayout("V2"),
            },
            {
                key: 'V3',
                text: t('data-lang-btn-view-v3'),
                ///iconProps: { iconName: 'AssessmentGroup' },
                onClick: () => onSwitchLayout("V3"),
            }
        ],
    };

    const toolBarItems_BookInfo_View = {
        items: [
            {
                key: 'create',
                text: window.location.pathname.toString().toLowerCase().startsWith(__SystemPagesPaths[__enum_SystemPages.BookCreation].text.toLowerCase()) ? t('data-lang-btn-viewmessages') : t('data-lang-btn-viewbook'),
                iconProps: { iconName: 'View' },
                onClick: onViewBookMessages,
            },
            {
                key: 'viewPartys',
                text: t('data-lang-btn-viewpartys'),
                iconProps: { iconName: 'AssessmentGroupTemplate' },
                onClick: onViewPartys,
            },
            {
                key: 'viewSections',
                text: t('data-lang-btn-viewsections'),
                iconProps: { iconName: 'AssessmentGroup' },
                onClick: onViewSections,
            },
            {
                key: 'viewUsers',
                text: t('data-lang-btn-viewusers'),
                iconProps: { iconName: 'Group' },
                onClick: onViewUsers,
            },
            {
                key: 'viewdocuments',
                text: t('data-lang-btn-viewdocuments'),
                iconProps: { iconName: 'DocLibrary' },
                onClick: onViewDocuments,
            },
        ],
    };

    //Render de componente.
    return (
        <Card className='h-100'>
            <Card.Header className="card-header-compact">
                <Card.Title className="justify-content-between">
                    <Row>
                        {
                            inputParam_EditMode === true && inputParam_ShowNumber && (inputParam_IsCreatrionMode ? true : inputParam_UserHasConfigRoleAction) &&
                            <Col className='col-auto ms-auto'>
                                <StatusHeaderItem index={ 1 } statusId={ inputParam_StatusFly } />
                            </Col>
                        }
                        <Col className={ inputParam_EditMode && (inputParam_IsCreatrionMode ? true : inputParam_UserHasConfigRoleAction) ? "ps-4 ms-3" : "" } >
                            <b>{t('data-lang-boxname-bookinformation')}</b>
                        </Col>
                    </Row>
                </Card.Title>
            </Card.Header>
            <Card.Footer className='px-0' style={{borderBottom: "1px solid rgba(0, 0, 0, 0.125)"}}>
                <div className='book-toolbar d-flex float-end'>
                    {
                        inputParam_EditMode && (inputParam_IsCreatrionMode ? true : inputParam_UserHasConfigRoleAction) &&
                        <ActionButton onClick={objBook.id === null ? onCreateBook : onSaveBook} iconProps={{ iconName: 'Save' }} allowDisabledFocus>
                            { objBook.id === null ? t('data-lang-btn-create') :  t('data-lang-btn-save') }
                        </ActionButton>
                    }
                    {
                        (objBook.statusId === 2 || objBook.statusId === 3) && window.location.pathname.toString().toLowerCase().startsWith(__SystemPagesPaths[__enum_SystemPages.BookCreation].text.toLowerCase()) &&
                        <ActionButton onClick={ onViewBookMessages } iconProps={{ iconName: 'View' }} allowDisabledFocus>
                            { t('data-lang-btn-viewmessages') }
                        </ActionButton>
                    }
                    {
                        inputParam_ShowImpersonation &&
                        <>
                            <j className="d-none d-sm-block">
                            <ActionButton onClick={ onShowImpersonation } styles={{root: { border: selectedImpersonateUser === null ? "1px solid transparent;" : "1px solid #000", backgroundColor: selectedImpersonateUser === null ? "unset" : "#dadada" }}} iconProps={{ iconName: 'UserSync' }} allowDisabledFocus>
                                { selectedImpersonateUser === null ? t('data-lang-btn-impersonate') : selectedImpersonateUser.fullname }
                            </ActionButton>
                            </j>
                            <j className="d-block d-sm-none">
                                <TooltipHost content={ selectedImpersonateUser === null ? t('data-lang-btn-impersonate') : selectedImpersonateUser.fullname } >
                                    <ActionButton onClick={ onShowImpersonation } styles={{root: { border: selectedImpersonateUser === null ? "1px solid transparent;" : "1px solid #000", backgroundColor: selectedImpersonateUser === null ? "unset" : "#dadada" }}} iconProps={{ iconName: 'UserSync' }} allowDisabledFocus />
                                </TooltipHost>  
                            </j>
                        </>
                        
                    }
                    {
                        //[#NEW31082026#]SE COMENTA POR QUE LAS OTRAS VERSIONES TIENEN PROBLEMAS.
                        !inputParam_EditMode && inputParam_ShowSwitchLayout && false &&
                        <>
                            <j className="d-none d-sm-block">
                                <ToolBarDownFall items={ toolBarItems_BookInfo_SwitchLayout } display={ true } mainItem={ { iconName: 'Switch' } } mainItemText={ t('data-lang-btn-switchlayout') } />
                            </j>
                            <j className="d-block d-sm-none">
                                <TooltipHost content={ t('data-lang-btn-switchlayout') } >
                                    <ToolBarDownFall items={ toolBarItems_BookInfo_SwitchLayout } display={ true } mainItem={ { iconName: 'Switch' } } />
                                </TooltipHost>
                            </j>
                        </>
                    }
                    {
                        inputParam_EditMode && (inputParam_IsCreatrionMode ? true : inputParam_UserHasConfigRoleAction) &&
                        <ToolBar items={ toolBarItems_BookInfo_Edit } display={ false } />
                    }
                    {
                        !inputParam_EditMode && !window.location.pathname.toString().toLowerCase().startsWith(__SystemPagesPaths[__enum_SystemPages.BookCreation].text.toLowerCase()) &&
                        <>
                            <j className="d-none d-sm-block">
                                <ToolBarDownFall items={ toolBarItems_BookInfo_View } display={ true } mainItem={ { iconName: 'Add' } } mainItemText={ t('data-lang-btn-viewoptions') } /> 
                            </j>
                            <j className="d-block d-sm-none">
                                <TooltipHost content={ t('data-lang-btn-viewoptions') } >
                                    <ToolBarDownFall items={ toolBarItems_BookInfo_View } display={ true } mainItem={ { iconName: 'Add' } } />
                                </TooltipHost>  
                            </j>
                        </>
                    }
                </div>
            </Card.Footer>
            {
                inputParam_EditMode && (inputParam_IsCreatrionMode ? true : inputParam_UserHasConfigRoleAction) &&
                <Card.Body className='h-100'>
                    <Row>
                        <Col className='col' xl={4}>
                            <Toggle
                                checked={ objBook.requiresApproval }
                                onChange={ onRequiresApprovalChange }
                                role="checkbox"
                                onText={ t('data-lang-lbl-requiresapproval') }
                                offText={ `${t('data-lang-lbl-no')} ${(t('data-lang-lbl-requiresapproval')).toLowerCase()}` }
                                styles={ {root:{display: "flex"}, label: {marginRight : "5px"}} }
                            />
                        </Col>
                        <Col className='col' xl={4}>
                            <Toggle
                                checked={ objBook.autoSignature }
                                onChange={ onAutoSignatureChange }
                                role="checkbox"
                                onText={ `${t('data-lang-lbl-with')} ${(t('data-lang-lbl-autosignature')).toLowerCase()}` }
                                offText={ `${t('data-lang-lbl-without')} ${(t('data-lang-lbl-autosignature')).toLowerCase()}` }
                                styles={ {root:{display: "flex"}, label: {marginRight : "5px"}} }
                            />
                        </Col>
                        <Col className='col' xl={4}>
                            <Row>
                                <Col className='me-auto col-auto p-0'>
                                {
                                    objBook.hasMessages === true &&
                                    <CLabel labelText={ t('data-lang-lbl-hasmilestones') } aditionalStyles={{fontSize: '14px'}} labelValue={ objBook.hasMilestone ? t('data-lang-btn-yes') : t('data-lang-btn-no') } />
                                }
                                {
                                    (objBook.hasMessages === false || isNullUndefinedOrEmptyOrZero(objBook.id)) &&
                                    <Toggle
                                        checked={ objBook.hasMilestone }
                                        onChange={ onHasLapsChange }
                                        role="checkbox"
                                        onText={ t('data-lang-lbl-hasmilestones') }
                                        offText={ t('data-lang-lbl-nohasmilestones') }
                                        styles={ {root:{display: "flex"}, label: {marginRight : "5px"}} }
                                    />
                                }
                                </Col>
                                <Col className='me-auto col-auto p-0'>
                                
                                    <TeachBubble
                                        inputParam_ButtonId={ "btnHelpBookCreation_HasMilestone" }
                                        inputParam_Text={
                                                <Row>
                                                    <Col className='mb-2' xl={12}><b>{t('data-lang-helptext-bookcreation-hasMilestone-true-title')}</b>: {t('data-lang-helptext-bookcreation-hasMilestone-true-desc')}</Col>
                                                    <Col className='mb-2' xl={12}><b>{t('data-lang-helptext-bookcreation-hasMilestone-false-title')}</b>: {t('data-lang-helptext-bookcreation-hasMilestone-false-desc')}</Col>
                                                </Row>
                                            }
                                        inputParam_IsHTML={true} 
                                        inputParam_Title={ t('data-lang-helptext-title') }
                                    />
                                </Col>
                                <Col></Col>
                            </Row>
                            
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                            <CTextBox controlValue={ objBook.name } setterControlValue={ setNameValue } isInValid={txtNameIsInValid} textBoxName="name" labelText={ t('data-lang-lbl-name') } />
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                            <CTextBox editMode={ false } controlValue={ objBook.bookCode } setterControlValue={ setCodeValue } isInValid={txtCodeIsInValid} textBoxName="code" labelText={ t('data-lang-lbl-code') } />
                        </Col>
                    </Row>
                </Card.Body>
            }
            {
                !inputParam_EditMode &&
                <Card.Body className="small-card-body h-100">
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <CLabel labelText={ t('data-lang-lbl-name') } labelValue={ objBook.name } />
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                            <CLabel labelText={ t('data-lang-lbl-type') } labelValue={ objBook.mainBook ? t('data-lang-lbl-pdf-mainbook') : t('data-lang-lbl-pdf-auxiliar') } />
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                            <CLabel labelText={ t('data-lang-lbl-code') } labelValue={ objBook.bookCode } />
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                            <CLabel labelText={ t('data-lang-lbl-relatedconcept') } labelValue={ inputParam_RelatedConceptItem && inputParam_RelatedConceptItem.id !== null ? (inputParam_RelatedConceptItem.id > 0 ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')) : t('data-lang-lbl-no') } />
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                            <CLabel labelText={ t('data-lang-lbl-requiresapproval') } labelValue={ objBook.requiresApproval ? t('data-lang-btn-yes') : t('data-lang-btn-no') } />
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                            <CLabel labelText={ t('data-lang-lbl-autosignature') } labelValue={ objBook.autoSignature ? t('data-lang-btn-yes') : t('data-lang-btn-no') } />
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                            <CLabel labelText={ t('data-lang-lbl-hasmilestones') } labelValue={ objBook.hasMilestone ? t('data-lang-btn-yes') : t('data-lang-btn-no') } />
                        </Col>
                        {
                            inputParam_IsCreatrionMode === true &&
                            <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                                <CLabel labelText={ t('data-lang-lbl-status') } labelValue={ t(`data-lang-sbbook-status${objBook.statusId}`) } />
                            </Col>
                        }
                        {
                            inputParam_IsCreatrionMode === false &&
                            <Col xs={12} sm={6} md={6} lg={6} xl={6} className='d-flex'>
                            {
                                objBook.statusId !== 3 &&
                                <><CLabel labelText={ t('data-lang-lbl-status') } /><CLabel labelValue={ t(`data-lang-sbbook-status${objBook.statusId}`) } /></>
                            }
                            {
                                objBook.statusId === 3 &&
                                <><CLabel labelText={ t('data-lang-lbl-status') } /><b><CLabel labelValue={ t(`data-lang-sbbook-status${objBook.statusId}`) } aditionalStyles={{color: "#e74343"}} /></b></>
                            }
                            </Col>
                        }
                    </Row>
                    {
                        objBook.hasMilestone &&
                        <>
                            <Row className='border-top mt-3'>
                                <Col><b>{t('data-lang-lbl-bookmilestone')}</b></Col>
                            </Row>
                            <Row>
                            {
                                objBook.l_book_milestone && objBook.l_book_milestone.map((item, index) => (
                                    <TooltipHost
                                        key={index}
                                        content={t('data-lang-msg-infoinitmessage').replace('{0}', item.milestoneName)}
                                        hostClassName={css(classNames.overflow)}
                                        styles={{
                                            root: {
                                                display: 'flex',
                                                width: '100%'
                                            }
                                        }}
                                    >
                                        <Row>
                                            <Col className='d-flex'>
                                                <Icon styles={{root:{paddingTop:'3px', color: `${!item.complete ? 'orange': 'green'}`}}} iconName={`${!objBook.complete ? 'AlertSolid' : 'SkypeCircleCheck' }`} />
                                                <div className='ps-2'>
                                                    {
                                                        !isNullUndefinedOrEmpty(item.milestoneCode) ? t(`data-lang-lbl-${item.milestoneCode.toLocaleLowerCase()}`) : item.milestoneName
                                                    }
                                                </div>
                                            </Col>
                                        </Row>
                                    </TooltipHost>
                                ))
                            }
                        </Row>
                            <Row>
                                <Col className='d-flex'>
                                    <Icon styles={{root:{paddingTop:'3px', color: `${!objBook.hasEndMilestone ? 'orange': 'green'}`}}} iconName={`${!objBook.hasEndMilestone ? 'AlertSolid' : 'SkypeCircleCheck' }`} /><div className='ps-2'>{t('data-lang-lbl-closecommunicationdone')}</div>
                                </Col>
                            </Row>
                        </>
                    }
                    <SidePanelSections bookObject={ objBook } isPanelOpen={ isPanelViewSectionsOpen } setterIsPanelOpen={ setIsPanelViewSectionsOpen } />
                    <SidePanelPartys bookObject={ objBook } isPanelOpen={ isPanelViewPartysOpen } setterIsPanelOpen={ setIsPanelViewPartysOpen } />
                    <SidePanelViewUsers bookId={ objBook.id } isPanelOpen={ isPanelViewUsersOpen } setterIsPanelOpen={ setIsPanelViewUsersOpen } getBookList={true} />
                    <SidePanelImpersonate
                        bookId={ objBook.id }
                        isPanelOpen={ isPanelImpersonateOpen }
                        setterIsPanelOpen={ setIsPanelImpersonateOpen }
                        setterUserPropsObject={ inputParam_SetterUserPropsObject }
                        setterObjMessageList={ inputParam_SetterObjMessageList }
                        setterUserName={ inputParam_SetterUserName }
                        setterUser={ setSelectedImpersonateUser }
                    />
                    {
                        isModalDocumentOpen &&
                        <DocumentLinkModal
                            bookObject={objBook}
                            isModalOpen={ isModalDocumentOpen }
                            setIsModalOpen={setIsModalDocumentOpen}
                            setterSelectedDocumentToLink={ null }
                            editMode={ false }
                            userProps={inputParam_UserProps}
                        />
                    }
                </Card.Body>
            }
            <Card.Footer>
                <Message message={ message } display={ successful === null? false : showMessage } messageType={ messageType } setterShowMessage={ setShowMessage } />
            </Card.Footer>
        </Card>
    );
}

export default BookBox;